import React from 'react';
import StarsIcon from '@material-ui/icons/Stars';
import LoyaltyIcon from '@material-ui/icons/Loyalty';

interface OrderDetailLineProps {
    e: any;
    classes: any;
    displayPriceFormat: (price: string | number) => string;
}

const OrderDetailLine: React.FC<OrderDetailLineProps> = ({
    e,
    classes,
    displayPriceFormat,
}) => {
    const Badge = ({ icon: Icon, text }) => (
        <div className={classes.loyalty}>
            <Icon style={{ marginRight: '4px', fontSize: 10 }} />
            <b style={{ fontSize: 10 }}>{text}</b>
        </div>
    );

    return (
        <p className={classes.orderDetailStyle}>
            <div className={classes.labelStyle}>
                {`${!e.unit ? 'x' : ''}`}
                {e.nb} {`${e.unit ? `${e.unit} ` : ''}`} {e.name}

                {e?.isLoyaltyProduct && (
                    <Badge
                        icon={StarsIcon}
                        text={e.points}
                    />
                )}
            </div>

            {e?.productPromotionCode ? (
                <Badge
                    icon={LoyaltyIcon}
                    text="Offert"
                />
            ) : e.price && !e?.isLoyaltyProduct ? (
                displayPriceFormat(e.price)
            ) : (
                displayPriceFormat('')
            )}
        </p>

    );
};

export default OrderDetailLine;
